import { createContext, useContext } from "react";
import { IAssetClass } from "store/types";

export { Section } from "./Section";
export { CreateSubAssetClass } from "./CreateSubAssetClass";
export { CreateAssetClass } from "./CreateAssetClass";

export type NewAssetClass = {
  name: string;
  id: number;
  subAssetClasses: Array<{
    id: number;
    name: string;
    is_hidden: boolean;
  }>;
};

export interface IManageAssetClassesContext {
  createSubAsset: (data: { assetClassId: number }) => Promise<void>;
  deleteSubAsset: (data: { assetClassId: number; subAssetClassId: number }) => Promise<void>;
  updateAssetClass: (data: Pick<IAssetClass, "id"> & Partial<Pick<IAssetClass, "name" | "is_hidden">>) => Promise<void>;
  updateSubAssetClass: (data: { assetClassId: number; subAssetClassId: number; is_hidden?: boolean }) => Promise<void>;
  setIsHiddenSubAssets: (data: { assetClassId: number; is_hidden: boolean }) => Promise<void>;
  getSubAssetName: (checkIsValidName: (name: string) => string | null) => Promise<string | void>;
  deleteAssetClass: (id: number) => Promise<void>;
}

export const ManageAssetClassesContext = createContext<IManageAssetClassesContext>({} as IManageAssetClassesContext);

export const useManageAssetClassesContext = () => useContext(ManageAssetClassesContext);
